/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';

export default (set, get, isFromPip = false) => set(produce(get(), (draft) => {
  if (!draft.design) {
    draft.design = {};
  }

  draft.design.isFromPip = isFromPip;

}), false, { type: 'TOGGLE_IS_FROM_PIP' });